export let _sshService;

/**
 * Peering used to be force-injected here: any team with vpc_peering_host set had
 * ssh_host / ssh_user / ssh_port overwritten on every save, and the SSH rows
 * stripped from the displayed config. The customer could not see that their
 * traffic went through a tunnel, could not opt a publicly reachable source out
 * of it, and could not tell which of their peered ranges the host had to be in.
 *
 * With a real toggle, peering writes the triple into the form instead — Test
 * Connection reads form state, and a config with ssh_enabled and no host is
 * rejected by the backend validator — so this service just reads the form.
 *
 * `useSSH` is the only tunnel flag: peering fills the same three fields rather
 * than setting a second one, and which mode a config is in is derived from
 * `ssh_user` (see the toolkit's `isPeeringShaped`). Nothing peering-specific is persisted.
 */
export class SSHService {
  static deps = [];

  constructor() {
    _sshService = this;
  }

  buildSSHParams(params, data) {
    if (data.useSSH) {
      params.ssh_user = data.sshUser;
      params.ssh_host = data.sshIp;
      params.ssh_port = data.sshPort;
    }
  }

  sshEnabled(data) {
    return !!data.useSSH;
  }

  getSSHParams(data) {
    if (data.useSSH) {
      return {
        ssh_host: data.sshIp,
        ssh_user: data.sshUser,
        ssh_port: data.sshPort
      };
    }

    return undefined;
  }
}
